import { api } from '../https'

export class FavoritesService {
  static async addFavoritePageId(id: string) {
    const res = await api.post(`/v3/my/favorites/pages/${id}`)
    if (res.status >= 400) {
      throw new Error('Something went wrong')
    }
    return res
  }

  static async removeFavoritePageId(id: string) {
    const res = await api.delete(`/v3/my/favorites/pages/${id}`)
    if (res.status >= 400) {
      throw new Error('Something went wrong')
    }
    return res
  }

  static async getFavoritePageIds(): Promise<Array<string>> {
    const res = await api.get(`/v3/my/favorites`)
    return res?.data?.pageIds || []
  }

  static async updateFavoritePageIds(pageIds: Array<string>) {
    const res = await api.put(`/v3/my/favorites`, {
      pageIds,
    })
    if (res.status >= 400) {
      throw new Error('Something went wrong')
    }
    return res
  }
}
